<template>
  <div class="mbox" :class="{ active: isshow }" @click="close">
    <div class="hbdt" @click.stop="">
      <CloseCircleOutlined class="sktkqer" @click.stop="close" />
      <div class="skdtht">
        <!-- {{ currentChat }} -->
        <img class="hexde asdskt" :src="currentChat.avatar" />
        <div class="hbmingz">{{ currentChat.name }}</div>
        <div>发出的红包</div>
      </div>
      <template v-if="redbag.user_type == 'right'">
        <div class="skjtqe" style="font-size: 15px">红包金额 ${{ redbag.content.amount || 0 }} 等待被领取</div>
      </template>
      <template v-else>
        <div class="skjtqe">恭喜发财，大吉大利</div>
        <!-- <div class="jine">${{ redbag?.content?.amount || 0 }}</div> -->
        <div class="stqwetr" @click.stop="openRedbag">打开红包</div>
      </template>
    </div>
  </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
export default {
  name: 'ChatShowRedBag',
  components: { CloseCircleOutlined },
  data() {
    return {
      //
      isshow: false,
      redbag: {},
      currentChat: {}
    }
  },
  created() {},
  methods: {
    showRedBag(redbag, currentChat) {
      this.isshow = true
      this.redbag = { ...redbag }
      const content = JSON.parse(redbag.content)
      this.redbag.content = content
      this.currentChat = { ...currentChat }
    },
    openRedbag() {
      this.$api.chat
        .receive({ msg_id: this.redbag.id })
        .then((res) => {
          if (res.code == 1) {
            this.$message.error(res.msg)
            return
          }
          this.$message.success(this.$t('_hb._qlcg'))
          this.isshow = false
          this.$emit('success', this.redbag.content.amount)
        })
        .catch(() => {
          // this.$message.error(err.msg || this.$t('_hb._qlsb'))
        })
    },
    close() {
      this.isshow = false
    }
  }
}
</script>

<style>
.mbox {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  background: rgb(0 0 0 / 50%);
}

.mbox.active {
  opacity: 1;
  visibility: visible;
}
.hbdt {
  background-image: url('../../static/redbag/redbag.png');
  background-size: 100% 100%;
  width: 240px;
  height: 300px;
  position: absolute;
  padding: 20px;
  border-radius: 20px;
  box-shadow: 0px 0 10px 0px #4e4e4e;
}

.asdskt {
  background: #fff;
  border-radius: 20px;
}
.sktkqer {
  position: absolute;
  top: 12px;
  right: 10px;
  font-size: 20px;
  color: #fff;
}
.sktkqer:hover {
  cursor: pointer;
  color: #ffec3d;
}

.hexde {
  width: 40px;
  height: 40px;
}

.skdtht {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
  gap: 5px;
}

.skjtqe {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  margin-top: 30px;
}

.stqwetr {
  color: #ffc107;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 145px;
  width: 100%;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
}

.hbmingz {
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.jine {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
}
</style>
